import * as React from 'react';
import { SiteContext } from '../context/SiteContext';

declare global {
  interface Window {
    gmap: any;
    circle: any;
  }
}

export const useMap = () => {
  const { setGoogleMapInitialized, setGoogleMapInstance } = React.useContext(
    SiteContext
  );

  React.useEffect(() => {
    window.gmap = null;
    window.circle = null;
    if (window.google) {
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyC8Reux2Pd0dy99geYrYdwukb4byrcqsYc&libraries=places&callback=initMap';
    script.defer = true;
    script.async = true;
    window.initMap = () => {
      setGoogleMapInitialized(true);
      setGoogleMapInstance(window.google);
    };
    document.head.appendChild(script);
  }, []);
};
